import { StrapiCityEntityApi, StrapiData } from '@core/const';
import { ProductCodes, ProductRecommendationPage, RecommendationAlgorithm } from '.';

export const ProductRecommendationCarouselTypes = {
  PRODUCT_LIST: 'product-list',
  ALGORITHM_LIST: 'algorithm-list',
  COMBINED: 'combined',
};

export type ProductRecommendationCarouselTypes =
  (typeof ProductRecommendationCarouselTypes)[keyof typeof ProductRecommendationCarouselTypes];

export interface ProductRecommendationEntityStrapi {
  page: ProductRecommendationPage;
  carouselType: ProductRecommendationCarouselTypes;
  title: string;
  citiesIncluded?: StrapiData<StrapiCityEntityApi>;
  citiesExcluded?: StrapiData<StrapiCityEntityApi>;
  productCodes?: ProductCodes[];
  algorithms?: StrapiData<RecommendationAlgorithm>;
  itemLimits?: number;
}

export interface ProductRecommendationEntity {
  page: ProductRecommendationPage;
  carouselType: ProductRecommendationCarouselTypes;
  title: string;
  productCodes?: ProductCodes[];
  algorithms?: RecommendationAlgorithm[];
  itemLimits?: number;
}
